<template>
  <q-page class="q-pa-md column page-linear">
    <div class="q-mt-xl"></div>
    <img
      class="self-center q-mt-xl"
      src="../assets/NotFound.svg"
      alt="Not found"
    />
    <div class="self-center text-h5 text-white text-center">
      {{t('notfound.text')}}
    </div>
    <router-link class="self-center q-mt-xl" to="dashboard">
    <q-icon name="mdi-arrow-right" class="text-white q-mr-md" style="font-size: 3em;" />
    <q-btn color="blue-7" push>
      <div class="row items-center no-wrap">
        <q-icon left name="mdi-home" />
        <div class="text-center">{{t("notfound.label1")}} <br/>{{t("notfound.label2")}}</div>
      </div>
    </q-btn>
     <q-icon name="mdi-arrow-left" class="q-ml-md text-white" style="font-size: 3em;" />
    </router-link>
  </q-page>
</template>
<script>
import { useI18n } from 'vue-i18n';

export default {
  name: "404",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'local'
    });
    return {t}
  }
};
</script>
<style>
.page-linear {
 background: linear-gradient(-45deg,rgb(96, 156, 96),rgb(88, 200, 84));
}
</style>